import { CssBaseline } from "@material-ui/core"
import AppBar from "@material-ui/core/AppBar"
import Link from "@material-ui/core/Link"
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import * as React from "react"
import { Link as RouteLink, Route, Switch } from "react-router-dom"
import { RoutePaths } from "../../../portal-app/src/routing/RoutePaths"
import { CCUtils } from "../common/CCUtils"
import { StudentChooseBuddy } from "./login/StudentChooseBuddy"
import { StudentCreateAccount } from "./login/StudentCreateAccount"
import { StudentCreateScreenname } from "./login/StudentCreateScreenname"
import { StudentJoinClass } from "./login/StudentJoinClass"
import { StudentLoginPage } from "./login/StudentLoginPage"
import { appTheme, spacing } from "./StyleUtils"
import { TechCheck } from "./TechCheck"

const clickCityLogo = CCUtils.asset("generic/images/click-city.png")

export class WebApp extends React.Component {
    render() {
        return (
            <MuiThemeProvider theme={appTheme}>
                <CssBaseline/>
                <TechCheck/>
                <div>
                    <AppBar position={"static"}>
                        <Toolbar>
                            <RouteLink to={RoutePaths.home}>
                                <img alt={"Click City"} src={clickCityLogo} style={{width: spacing(6), height: spacing(6)}}/>
                            </RouteLink>
                            <Typography
                                variant={"h5"}
                                style={{flexGrow: 1, marginLeft: spacing(4)}}
                                color={"inherit"}>

                                <Link component={RouteLink} to={RoutePaths.home} color={"inherit"} underline={"none"}>Login</Link>
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <div
                        style={{
                            margin: appTheme.spacing(4),
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        <Switch>
                            <Route
                                path={LoginRoutes.joinClass}
                                component={StudentJoinClass}
                            />
                            <Route
                                path={LoginRoutes.createStudentAccount}
                                component={StudentCreateAccount}
                            />
                            <Route
                                path={LoginRoutes.chooseBuddy}
                                component={StudentChooseBuddy}
                            />
                            <Route
                                path={LoginRoutes.createScreenName}
                                component={StudentCreateScreenname}
                            />
                            <Route
                                exact={true}
                                component={StudentLoginPage}
                            />
                        </Switch>
                    </div>
                </div>
            </MuiThemeProvider>
        )
    }
}

// TODO figure out why all the assets die when you have more than one /
export const LoginRoutes = {
    studentLogin: "/",
    joinClass: "/join-class",
    createStudentAccount: "/create-student-account",
    chooseBuddy: "/choose-buddy",
    createScreenName: "/create-screen-name"
}
